import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import DrinkSectionForm from './DrinkSectionForm'

const DrinkSectionEdit: React.FC = () => (
  <SectionWrapper title={'resources.drinksections.editSection'}>
    <Edit>
      <DrinkSectionForm toolbar={<WithDeleteModalToolbar />} />
    </Edit>
  </SectionWrapper>
)

export default DrinkSectionEdit
